export default __webpack_public_path__ + "static/media/microsoft.e9ddb3bc.svg";